import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GroupsEffects } from './+state/groups.effects';
import { GroupsFacade } from './+state/groups.facade';
import * as fromGroups from './+state/groups.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromGroups.GROUPS_FEATURE_KEY, fromGroups.reducer),
    EffectsModule.forFeature([GroupsEffects]),
  ],
  providers: [GroupsFacade],
})
export class OnmatStoreGroupModule {}
